const CryptoJS = require('crypto-js')
// 实现登录加密
export default {
  // 加密
  encrypt (word, keyStr) {
    if (!keyStr) {
      keyStr = 'QINGENG123456789'
    }
    // keyStr = keyStr ? keyStr : 'absoietlj32fai12'
    let key = CryptoJS.enc.Utf8.parse(keyStr)
    let srcs = CryptoJS.enc.Utf8.parse(word)
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    // console.log(CryptoJS.enc.Base64.stringify(encrypted.ciphertext))
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
  },
  // 解密
  decrypt (word, keyStr) {
    if (!keyStr) {
      keyStr = '1234567890ABCDEF'
    }
    var key = CryptoJS.enc.Utf8.parse(keyStr)
    var decrypt = CryptoJS.AES.decrypt(word, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
  }
}



//////////////////
// WEBPACK FOOTER
// ./utils/CryptoJS.js
// module id = null
// module chunks = 